// extracted by mini-css-extract-plugin
export var blockCheckoutModal = "style-mod--block-checkout-modal--c9fff";
export var continueShopping = "style-mod--continue-shopping--9e799";
export var modal = "style-mod--modal--5a003";
export var modalClose = "style-mod--modal-close--465c4";
export var modalCloseContainer = "style-mod--modal-close-container--1bb77";
export var modalCloseDesktop = "style-mod--modal-close-desktop--a16af";
export var modalCloseDesktopDesktop = "style-mod--modal-close-desktop-desktop--d3b81";
export var modalCloseDesktopResponsive = "style-mod--modal-close-desktop-responsive--938a3";
export var modalCloseResponsive = "style-mod--modal-close-responsive--786ec";
export var modalDescription = "style-mod--modal-description--5326c";
export var modalTitle = "style-mod--modal-title--bdf6c";
export var subscribeContainer = "style-mod--subscribe-container--d0b93";
export var success = "style-mod--success--0151f";